import { useHeaderStateContext } from '../../context/header-state-context';

export const DrawerOverlay = () => {
  const {
    menuState: { isMenuOpen, isAccountOpen, closeMenus },
  } = useHeaderStateContext();

  const isVisible = isMenuOpen || isAccountOpen;
  if (!isVisible) return null;
  return (
    <div
      className="absolute top-0 z-50 h-screen w-full animate-fadein overflow-hidden bg-overlay backdrop-blur-[2px]"
      data-testid="backgroundOverlay"
      onClick={closeMenus}
    />
  );
};
